


























































import Vue from 'vue';
import Component from 'vue-class-component';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { layout, reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { ReportsHistoryDatatableItem } from '@/modules/reports/management/domain/reports-history-datatable';
import { HistoryState } from '@/modules/reports/management/domain/history.state';
import { Watch } from 'vue-property-decorator';
import DownloadReportModal from '@/modules/reports/management/components/DownloadReportModal.vue';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';
import { ReportsManagementGetters } from '@/modules/reports/management/store/reports-management.getters';

@Component({
    name: 'reports-view',
    components: { DownloadReportModal, SectionTitle },
})
export default class ReportsView extends Vue {
    searchReports: string = '';
    limitReports: number = 20;
    pageReports: number = 1;
    itemsPerPageReports: number[] = [5, 10, 15, 20];
    headersReports: {}[] = [
        { text: 'Registro', value: 'date', align: 'start', sortable: false },
        { text: 'Parámetro', value: 'parameter', align: 'start', sortable: false },
        { text: 'Valor', value: 'value', align: 'end', sortable: false },
        { text: 'Equipo', value: 'equipment', align: 'start', sortable: false },
        { text: 'Centro', value: 'location', align: 'start', sortable: false },
    ];
    reportsOptions: any = {};
    isFetchingReports: boolean = false;

    $refs!: {
        modal: any;
    };

    async changePageReportsDayco() {
        this.isFetchingReports = true;
        const failed = await this.fetchReports({
            limit: this.limitReports,
            start: this.pageReports,
        });
        if (failed) {
            (failed as ExceptionMessage).showError();
        }
        this.isFetchingReports = false;
    }

    async mounted() {
        this.changeTitle({ title: 'Reportes', route: ['Histórico'] });
        await this.fetchReports({ limit: this.limitReports, start: this.pageReports });
    }

    @Watch('reportsOptions.itemsPerPage')
    onItemsPerPageChangedOnReports(value) {
        this.limitReports = value;
        this.changePageReportsDayco();
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: LayoutTitle) => void;

    @reportsManagement.Action(ReportsManagementActions.FETCH_HISTORY_REPORTS)
    fetchReports!: (options: { limit: number; start: number }) => Promise<RequestResponse>;

    @reportsManagement.Getter(ReportsManagementGetters.GET_HISTORY_REPORTS)
    reports!: ReportsHistoryDatatableItem[];

    @reportsManagement.Getter(ReportsManagementGetters.GET_HISTORY)
    historyOptions!: HistoryState;
}
